import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

export const useUserRoleOptions = (options?: { enabled?: boolean }) => {
  const user = useAppSelector((state) => state.user);
  const orgId = user.organization_id;

  return useQuery({
    queryKey: [{ entity: "userRoleOptions" }],
    queryFn: async () =>
      await apiClient.getUserRoleOptions({
        params: { org_id: orgId },
      }),
    ...options,
  });
};
